// const URL = '/'
import axios from 'axios'

const apiVersion = ''

function getCookie(name) {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`
  ))
  return matches ? decodeURIComponent(matches[1]) : undefined
}

const headers = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRFToken': getCookie('csrftoken'),
}

export default () => axios.create({
  baseURL: apiVersion,
  headers,
})



// WEBPACK FOOTER //
// ./src/js/components/app/services/Api.js